<template>
  <section class="hero" id="home">
    <div class="hero-background"></div>

    <div class="hero-content">
      <div class="logo-container" data-aos="fade-down">
        <img src="/logo.png" alt="Oasis Logo" class="logo" />
      </div>

      <h1 class="hero-title" data-aos="fade-up" data-aos-delay="100">
        <span class="title-line">La microfinance</span>
        <span class="title-line accent">simple, pour tous</span>
      </h1>

      <p class="hero-subtitle" data-aos="fade-up" data-aos-delay="200">
        Oasis, votre partenaire pour un financement inclusif, rapide et transparent.
        <span class="subtitle-highlight">Sans frais cachés.</span>
      </p>

      <div class="cta-container" data-aos="fade-up" data-aos-delay="300">
        <a href="#contact" class="cta-btn">
          <span>Je découvre</span>
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
            <path d="M5 12h14M12 5l7 7-7 7" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
          </svg>
        </a>
        <a href="#features" class="secondary-btn">
          <span>Nos atouts</span>
        </a>
      </div>

      <div class="stats-container" data-aos="fade-up" data-aos-delay="400">
        <div class="stat-item">
          <span class="stat-number" data-count="15000">0</span>
          <span class="stat-label">Clients satisfaits</span>
        </div>
        <div class="stat-item">
          <span class="stat-number">24h</span>
          <span class="stat-label">Délai moyen</span>
        </div>
        <div class="stat-item">
          <span class="stat-number" data-count="95">0</span>
          <span class="stat-label">Taux d'approbation</span>
        </div>
      </div>
    </div>

    <div class="hero-wave">
      <svg viewBox="0 0 1200 120" preserveAspectRatio="none">
        <path d="M0,0V46.29c47.79,22.2,103.59,32.17,158,28,70.36-5.37,136.33-33.31,206.8-37.5C438.64,32.43,512.34,53.67,583,72.05c69.27,18,138.3,24.88,209.4,13.08,36.15-6,69.85-17.84,104.45-29.34C989.49,25,1113-14.29,1200,52.47V0Z" opacity=".25" fill="#1cc48d"></path>
        <path d="M0,0V15.81C13,36.92,27.64,56.86,47.69,72.05,99.41,111.27,165,111,224.58,91.58c31.15-10.15,60.09-26.07,89.67-39.8,40.92-19,84.73-46,130.83-49.67,36.26-2.85,70.9,9.42,98.6,31.56,31.77,25.39,62.32,62,103.63,73,40.44,10.79,81.35-6.69,119.13-24.28s75.16-39,116.92-43.05c59.73-5.85,113.28,22.88,168.9,38.84,30.2,8.66,59,6.17,87.09-7.5,22.43-10.89,48-26.93,60.65-49.24V0Z" opacity=".5" fill="#1cc48d"></path>
        <path d="M0,0V5.63C149.93,59,314.09,71.32,475.83,42.57c43-7.64,84.23-20.12,127.61-26.46,59-8.63,112.48,12.24,165.56,35.4C827.93,77.22,886,95.24,951.2,90c86.53-7,172.46-45.71,248.8-84.81V0Z" fill="#1cc48d"></path>
      </svg>
    </div>

    <!-- Floating particles -->
    <div class="particles">
      <div class="particle" v-for="n in 20" :key="n" :style="particleStyle(n)"></div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'HeroSection',
  mounted() {
    this.animateCounters()
    this.initParallax()
  },
  methods: {
    animateCounters() {
      const counters = document.querySelectorAll('[data-count]')
      counters.forEach(counter => {
        const target = parseInt(counter.getAttribute('data-count'))
        const duration = 2000
        const step = target / (duration / 16)
        let current = 0

        const timer = setInterval(() => {
          current += step
          if (current >= target) {
            counter.textContent = target.toLocaleString() + (counter.textContent.includes('%') ? '%' : '+')
            clearInterval(timer)
          } else {
            counter.textContent = Math.floor(current).toLocaleString() + (counter.textContent.includes('%') ? '%' : '+')
          }
        }, 16)
      })
    },
    initParallax() {
      window.addEventListener('scroll', () => {
        const scrolled = window.pageYOffset
        const background = document.querySelector('.hero-background')
        if (background) {
          background.style.transform = `translateY(${scrolled * 0.5}px)`
        }
      })
    },
    particleStyle() {
      return {
        left: `${Math.random() * 100}%`,
        animationDelay: `${Math.random() * 5}s`,
        animationDuration: `${5 + Math.random() * 10}s`
      }
    }
  }
}
</script>

<style scoped>
.hero {
  position: relative;
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  overflow: hidden;
  padding: 2rem 1rem;
  text-align: center;
}

.hero-background {
  position: absolute;
  top: -100px;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(135deg, #044c3a 0%, #0f4c75 50%, #1cc48d 100%);
  z-index: 0;
}

.hero-background::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: url('@/assets/image/accueil3.jpg') center/cover no-repeat;
  opacity: 0.08;
  animation: slowZoom 20s ease-in-out infinite alternate;
}

@keyframes slowZoom {
  from { transform: scale(1); }
  to { transform: scale(1.1); }
}

.hero-content {
  position: relative;
  z-index: 2;
  max-width: 1200px;
  margin: 0 auto;
  padding: 2rem;
}

.logo-container {
  margin: 0 auto 2rem;
  width: 120px;
  animation: float 3s ease-in-out infinite;
}

@keyframes float {
  0%, 100% { transform: translateY(0px); }
  50% { transform: translateY(-15px); }
}

.logo {
  width: 100%;
  filter: drop-shadow(0 5px 15px rgba(0,0,0,0.3));
}

.hero-title {
  font-size: clamp(2.5rem, 6vw, 4rem);
  font-weight: 800;
  line-height: 1.2;
  margin-bottom: 2rem;
  text-shadow: 2px 2px 8px rgba(0,0,0,0.3);
}

.title-line {
  display: block;
}

.accent {
  color: #f8f32b;
  position: relative;
  animation: glow 2s ease-in-out infinite;
}

@keyframes glow {
  0%, 100% { text-shadow: 0 0 20px rgba(248, 243, 43, 0.5); }
  50% { text-shadow: 0 0 40px rgba(248, 243, 43, 0.8); }
}

.accent::after {
  content: '';
  position: absolute;
  bottom: 5px;
  left: 0;
  width: 100%;
  height: 12px;
  background: rgba(248, 243, 43, 0.3);
  z-index: -1;
  border-radius: 4px;
}

.hero-subtitle {
  font-size: clamp(1.1rem, 2.5vw, 1.4rem);
  max-width: 700px;
  margin: 0 auto 3rem;
  line-height: 1.8;
  text-shadow: 1px 1px 4px rgba(0,0,0,0.3);
}

.subtitle-highlight {
  display: inline-block;
  font-weight: 700;
  background: rgba(255,255,255,0.2);
  padding: 0.3rem 0.8rem;
  border-radius: 6px;
  margin-top: 0.5rem;
  backdrop-filter: blur(10px);
}

.cta-container {
  display: flex;
  gap: 1.5rem;
  justify-content: center;
  margin-bottom: 4rem;
  flex-wrap: wrap;
}

.cta-btn,
.secondary-btn {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  padding: 1rem 2.5rem;
  border-radius: 50px;
  text-decoration: none;
  font-size: 1.1rem;
  font-weight: 600;
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;
}

.cta-btn {
  background: #f8f32b;
  color: #0a2e38;
  box-shadow: 0 6px 20px rgba(248, 243, 43, 0.4);
}

.cta-btn::before {
  content: '';
  position: absolute;
  top: 50%;
  left: 50%;
  width: 0;
  height: 0;
  border-radius: 50%;
  background: rgba(255,255,255,0.3);
  transform: translate(-50%, -50%);
  transition: width 0.6s, height 0.6s;
}

.cta-btn:hover::before {
  width: 300px;
  height: 300px;
}

.cta-btn:hover {
  background: #fff;
  transform: translateY(-4px);
  box-shadow: 0 10px 30px rgba(248, 243, 43, 0.5);
}

.secondary-btn {
  background: transparent;
  color: white;
  border: 2px solid rgba(255,255,255,0.5);
  backdrop-filter: blur(10px);
}

.secondary-btn:hover {
  background: rgba(255,255,255,0.15);
  border-color: white;
  transform: translateY(-4px);
}

.stats-container {
  display: flex;
  justify-content: center;
  gap: 3rem;
  flex-wrap: wrap;
  max-width: 900px;
  margin: 0 auto;
}

.stat-item {
  background: rgba(255,255,255,0.1);
  backdrop-filter: blur(10px);
  padding: 2rem;
  border-radius: 16px;
  min-width: 140px;
  transition: all 0.3s ease;
  border: 1px solid rgba(255,255,255,0.2);
}

.stat-item:hover {
  transform: translateY(-8px);
  background: rgba(255,255,255,0.15);
  box-shadow: 0 10px 30px rgba(0,0,0,0.2);
}

.stat-number {
  display: block;
  font-size: 2.5rem;
  font-weight: 800;
  color: #f8f32b;
  margin-bottom: 0.5rem;
  text-shadow: 2px 2px 6px rgba(0,0,0,0.3);
}

.stat-label {
  font-size: 1rem;
  opacity: 0.95;
  font-weight: 500;
}

.hero-wave {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 150px;
  z-index: 1;
}

.hero-wave svg {
  width: 100%;
  height: 100%;
}

/* Particles */
.particles {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
  z-index: 1;
  pointer-events: none;
}

.particle {
  position: absolute;
  width: 4px;
  height: 4px;
  background: rgba(255,255,255,0.5);
  border-radius: 50%;
  animation: float-particle linear infinite;
}

@keyframes float-particle {
  0% {
    transform: translateY(100vh) rotate(0deg);
    opacity: 0;
  }
  10% {
    opacity: 1;
  }
  90% {
    opacity: 1;
  }
  100% {
    transform: translateY(-100px) rotate(360deg);
    opacity: 0;
  }
}

@media (max-width: 768px) {
  .hero {
    padding: 6rem 1rem 4rem;
    min-height: auto;
  }

  .logo-container {
    width: 90px;
  }

  .cta-container {
    flex-direction: column;
    align-items: center;
    gap: 1rem;
  }

  .cta-btn,
  .secondary-btn {
    width: 100%;
    max-width: 300px;
    justify-content: center;
  }

  .stats-container {
    gap: 1.5rem;
  }

  .stat-item {
    padding: 1.5rem 1rem;
    min-width: 110px;
  }

  .stat-number {
    font-size: 2rem;
  }

  .stat-label {
    font-size: 0.9rem;
  }
}
</style>